import { render, staticRenderFns } from "./ListBarangMasuk.vue?vue&type=template&id=2e42fcb1&"
import script from "./ListBarangMasuk.vue?vue&type=script&lang=js&"
export * from "./ListBarangMasuk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports